<template>
  <div>
    <el-collapse v-model="collapseActiveName" v-for="(i, index) in checkList" :key="index">
      <el-collapse-item title="危险源辨识信息" :name="'identify' + index">
        <EquipIdentify
          v-if="type === 'equip'"
          :disabled="true"
          :taskId="i.equipmentFacilitySourcesDangerIdentifyId"
        />
        <JobIdentify
          v-if="type === 'job'"
          :disabled="true"
          :taskId="i.jobSourcesDangerIdentifyId"
        />
      </el-collapse-item>
      <el-collapse-item title="管控措施信息" :name="'control' + index">
        <div class="bg-table-header py-20px text-center">
          {{ i.sourcesDangerRecognitionRiskAssessControlDtos | methodsText }}
        </div>
      </el-collapse-item>
      <el-collapse-item title="隐患排查信息" :name="'checkListForm' + index">
        <CheckListForm :formProps="formProps" :formData="i" ref="checkListForm" />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import EquipIdentify from './EquipIdentify'
import JobIdentify from './JobIdentify'
import CheckListForm from './CheckListForm'

const uuid = require('uuid')

export default {
  name: 'check-list-info',
  components: {
    EquipIdentify,
    JobIdentify,
    CheckListForm,
  },
  props: {
    // 设备设施和作业活动 'equip'|'job'
    type: {
      default: 'equip',
    },
    dataList: {
      default: [],
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  filters: {
    methodsText(list) {
      if (list && list.length) {
        return list
          .map((item, index) => {
            return `${index + 1}、${item.existingControlMehtod}`
          })
          .join(';')
      }
      return ''
    },
  },
  data() {
    return {
      checkList: [],
      collapseActiveName: [],
    }
  },
  created() {
    this.checkList = this.dataList
    this.setCollapse()
  },
  mounted() {},
  methods: {
    setCollapse() {
      this.checkList.forEach((item, index) => {
        this.collapseActiveName.push(`checkListForm${index}`)
      })
    },
    getData() {
      if (!(this.checkList && this.checkList.length)) {
        return []
      }
      const formList = this.$refs.checkListForm.map((component) => {
        return component.validateData()
      })
      return formList.indexOf(false) > -1 ? false : formList
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-collapse-item__content {
  padding: 0px;
}
::v-deep .text-right {
  display: none;
}
</style>
